__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "shared";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] = scope[name] || {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult?.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("@tanstack/react-query", "5.105.0", () => (() => (__webpack_require__(5038))), 1);
			register("axios", "1.20.0", () => (() => (__webpack_require__(772))), 1);
			register("formik", "2.4.9", () => (() => (__webpack_require__(1132))), 1);
			register("i18next", "25.10.10", () => (() => (__webpack_require__(2635))), 1);
			register("react-dom", "18.3.1", () => (() => (__webpack_require__(961))), 1);
			register("react-helmet-async", "2.0.5", () => (() => (__webpack_require__(3662))), 1);
			register("react-hot-toast", "2.6.1", () => (() => (__webpack_require__(888))), 1);
			register("react-i18next", "16.6.6", () => (() => (__webpack_require__(9486))), 1);
			register("react-icons", "5.7.0", () => (() => (__webpack_require__(99))), 1);
			register("react-router-dom", "7.18.4", () => (() => (__webpack_require__(39))), 1);
			register("react", "18.3.1", () => (() => (__webpack_require__(6540))), 1);
			register("styled-components", "6.6.0", () => (() => (__webpack_require__(3679))), 1);
			register("yup", "1.7.1", () => (() => (__webpack_require__(5611))), 1);
			register("zustand", "5.0.16", () => (() => (__webpack_require__(5618))), 1);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};